import React, { createContext, useContext, useState } from "react";

const DeedsUIContext = createContext(null);

export const useDeedsUI = () => {
  const ctx = useContext(DeedsUIContext);
  if (!ctx) {
    throw new Error("useDeedsUI must be used inside DeedsUIProvider");
  }
  return ctx;
};

export const DeedsUIProvider = ({ children }) => {
  const [chipValues, setChipValues] = useState([]);

  const addDescriptionChip = (description) =>
    setChipValues((prev) => [
      ...prev.filter((chip) => chip.type !== "Deed"),
      { title: description, type: "Deed" },
    ]);

  const addBucketChip = (bucket) =>
    setChipValues((prev) => [
      ...prev.filter((chip) => chip.type !== "Bucket"),
      { title: bucket, type: "Bucket" },
    ]);

  return (
    <DeedsUIContext.Provider
      value={{ chipValues, setChipValues, addDescriptionChip, addBucketChip }}
    >
      {children}
    </DeedsUIContext.Provider>
  );
};
